import { ViewportScroller } from '@angular/common';
import { Event, NavigationEnd, Router, Scroll } from '@angular/router';
import { filter, Subscription } from 'rxjs';

const pathnameOf = (url: string): string => url.split('?')[0].split('#')[0];

const scrollEventUrl = (event: Scroll): string =>
  event.routerEvent instanceof NavigationEnd ? event.routerEvent.urlAfterRedirects : event.routerEvent.url;

/**
 * Scroll-to-top только при смене pathname; query-only навигации позицию не трогают.
 * Back/forward восстанавливают `Scroll.position`, якоря — через ViewportScroller.
 * Использовать вместе с `withInMemoryScrolling({ scrollPositionRestoration: 'disabled' })`.
 */
export const subscribeRouterScrollRestoration = (router: Router, viewportScroller: ViewportScroller): Subscription => {
  let lastPathname = pathnameOf(router.url);

  return router.events.pipe(filter((e: Event): e is Scroll => e instanceof Scroll)).subscribe((event) => {
    const pathname = pathnameOf(scrollEventUrl(event));

    if (event.position) {
      viewportScroller.scrollToPosition(event.position);
    } else if (event.anchor) {
      viewportScroller.scrollToAnchor(event.anchor);
    } else if (pathname !== lastPathname) {
      viewportScroller.scrollToPosition([0, 0]);
    }

    lastPathname = pathname;
  });
};
